<template lang="pug">
v-expansion-panel  
    v-expansion-panel-content(class="slim-header")
        template(v-slot:actions)
            div(class='header-btn-area')
                AppOutlinedButton MANAGE

        div( slot="header" )
            v-layout.text-xs-left.pa-2
                .subheading(v-if="name")
                    | {{ name }}

                    div
                        a( v-if="readMoreLink" @click.native.stop :href="readMoreLink" target="_blank" ) Learn more about the integration here

        v-divider

        v-card-text
            template(v-for="(item, i) in description")
                template(v-if="typeof item === 'string'")
                    br(v-if="i != 0 && stringAllCaps(description[i])")
                    template(v-if="item === 'SIGN-UP'")
                        p(
                            class="grey--text text--darken-3 descriptionItem"
                        ) SIGN-UP
                        p(
                            class="grey--text text--darken-3 descriptionItem"
                            style="padding-left: 40px;"
                        ) If you're not already enrolled, enroll now to get started!
                        v-btn.pr-5( 
                            flat 
                            color="primary"
                            style="padding-left: 40px;"
                        )
                            a(:href="enrollmentLink") Enroll Now
                    p(
                        v-else
                        class="grey--text text--darken-3 descriptionItem"
                        v-html="item")
                template(v-else-if="item.constructor === Array")
                    ul(class="ml-3 grey--text text--darken-3")
                        template(v-for="subpoint in item")
                            li(
                                v-html="subpoint"
                                style="list-style-type:disc"
                            )

            v-btn.pr-5( 
                style="float: right"
                flat 
                color="primary"
            )
                a(href="https://watsco.formstack.com/forms/c4c_lw") Register New Warranty

</template>
<script>
import { porch } from '@/helpers/integrations'
import AppOutlinedButton from 'Components/AppOutlinedButton.vue'
const { companyLogo, name, description, readMoreLink, enrollmentLink } = porch

export default {
    components: {
      AppOutlinedButton
    },
    data: () => ({
        companyLogo,
        name,
        description,
        readMoreLink,
        enrollmentLink
    }),
    methods: {
        stringAllCaps(str) {
            return str === str.toUpperCase()
        }
    }
}
</script>

<style lang="scss" scoped>
.descriptionItem {
    margin-top: 0;
    margin-bottom: 0;
}

.header-btn-area {
    height: 100%;
    min-height: 150px;
    align-self: self-end;
    display: flex;
    align-items: flex-end;
  }

@media (max-width: 375px) {
    .subheading {
        font-size: small !important;
    }
}
</style>
